export default __webpack_public_path__ + "static/media/17_PPEW4N-min.f613e9cf.jpg";